import { Outlet, useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { LogOut } from "lucide-react";
import { logout } from "@/lib/api";
import { useAuth, AUTH_QUERY_KEY } from "@/hooks/useAuth";

/**
 * Layout authentifié — reproduit la barre supérieure du site aurora-ds.com :
 * bandeau navy avec logo Aurora dans une carte blanche à gauche,
 * email + bouton logout à droite. Contenu en dessous, fond blanc.
 */
export function Layout() {
  const { user } = useAuth();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await logout();
    } finally {
      // Vider la session locale et rediriger même si l'appel échoue (cookie déjà expiré, réseau…).
      queryClient.setQueryData(AUTH_QUERY_KEY, null);
      navigate("/login", { replace: true });
    }
  };

  return (
    <div className="flex h-screen w-full flex-col overflow-hidden bg-background">
      {/* Header navy */}
      <header className="flex h-16 shrink-0 items-center justify-between bg-aurora-navy px-8 text-white shadow-md">
        <div className="flex items-center gap-4">
          {/* Carte blanche autour du logo (pattern site Aurora) */}
          <div className="flex items-center justify-center rounded-lg bg-white px-3 py-1.5">
            <img src="/logo-aurora.png" alt="Aurora Digital Solutions" className="h-8 w-auto" />
          </div>
          <div className="hidden sm:block">
            <div className="text-sm font-semibold leading-tight">Prospection</div>
            <div className="text-xs text-white/60">Aurora Digital Solutions</div>
          </div>
        </div>

        <div className="flex items-center gap-4">
          <div className="hidden text-sm text-white/80 md:block">{user?.email}</div>
          <button
            onClick={handleSignOut}
            className="flex items-center gap-2 rounded-md border border-white/20 px-3 py-1.5 text-xs font-medium text-white transition-colors hover:border-aurora-orange hover:text-aurora-orange"
            title="Se déconnecter"
          >
            <LogOut className="size-3.5" />
            <span className="hidden sm:inline">Déconnexion</span>
          </button>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
